import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.string.bold.js";
import React from 'react';
import styled from 'styled-components';
import RadioButton from './RadioButton';
import Flex, { Box } from 'components/Flex';
import HintTooltip from 'components/HintTooltip';
import Text from 'components/Text';
import useUniqueId from 'hooks/useUniqueId';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// These styles center the checkbox vertically next to the first line of
// its label, so that even when the label runs across multiple lines
// or changes its font size, it will be aligned correctly.
// To make this work, the line height needed to be hard-coded, but in the
// future, this should be updated to use the `lh` unit which always reflects
// the current line-height).

var CentredRadioButton = styled(RadioButton).withConfig({
  displayName: "RadioButtonOption__CentredRadioButton",
  componentId: "sc-1cc01o7-0"
})(["position:relative;top:calc(1em * ", " / 2);transform:translateY(-50%);"], function (p) {
  return p.theme.globals.lineHeight;
});
function getRadioButtonSize(fontSize) {
  if (fontSize === 'xxs' || fontSize === 'xs' || fontSize === 's') {
    return 'small';
  } else {
    return 'default';
  }
}
function RadioButtonOption(_ref) {
  var bold = _ref.bold,
    disabled = _ref.disabled,
    id = _ref.id,
    onChange = _ref.onChange,
    label = _ref.label,
    fontSize = _ref.fontSize,
    description = _ref.description,
    _ref$descriptionType = _ref.descriptionType,
    descriptionType = _ref$descriptionType === void 0 ? 'tooltip' : _ref$descriptionType,
    overflow = _ref.overflow,
    checked = _ref.checked,
    value = _ref.value;
  var uniqueId = useUniqueId(id);
  var isBold = bold === true || bold === 'auto' && !disabled && checked;
  var descriptionId = description ? "".concat(uniqueId, "-desc") : undefined;
  return /*#__PURE__*/_jsxs(Flex, {
    align: "top",
    fontSize: fontSize,
    dimmed: disabled,
    bold: isBold,
    children: [/*#__PURE__*/_jsx(CentredRadioButton, {
      id: uniqueId,
      "aria-describedby": descriptionId,
      checked: checked,
      onChange: onChange,
      disabled: disabled,
      value: value,
      size: getRadioButtonSize(fontSize)
    }), /*#__PURE__*/_jsxs(Box, {
      grow: true,
      shrink: true,
      overflow: overflow,
      ml: "xs",
      children: [/*#__PURE__*/_jsx("label", {
        htmlFor: uniqueId,
        children: label
      }), description && (descriptionType === 'tooltip' ? /*#__PURE__*/_jsx(HintTooltip, {
        content: description,
        id: descriptionId,
        spacingLeft: "xxs"
      }) : /*#__PURE__*/_jsx(Text, {
        as: "p",
        size: "s",
        bold: false,
        id: descriptionId,
        children: description
      }))]
    })]
  });
}
export { RadioButton };
export default RadioButtonOption;